import { FC, PropsWithChildren } from "react";
import clsx from "clsx";
import { ColumnProps } from "@/components/column/types";
import styles from "./styles.scss";

export const Column: FC<PropsWithChildren<ColumnProps>> = ({
  className,
  children,
}) => <div className={clsx(styles.column, className)}>{children}</div>;
